import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth/auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class ReferralGuardGuard implements CanActivate {

  constructor(
    private router: Router,
    private authService: AuthService,
  ) {

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.authService.checkSession('1').pipe(map((response: any) => {
      if ((response.data?.email_verified == '0' && response.data?.office_email != '') || (response.data?.sms_verified == '0' && response.data?.mobile != '' && response.data?.country_code == '91')) {
        this.router.navigate(['signup'], { queryParams: {}, queryParamsHandling: 'merge' });
        return false;
      } else if (response.data?.is_referral_pending == '1') {
        return true;
      } else {
        if (environment.login_type === 'local_login') {
          return true;
        } else {
          this.router.navigate(['signup'], { queryParams: {}, queryParamsHandling: 'merge' });
          return false;
        };
      };
    }));
  }

}
